import { isEmpty } from 'lodash';

import {
  ACTIVE_STATUS,
  ASSET_TYPE_SEARCH_PLACEHOLDERS,
  ASSET_TYPE_SEARCH_PLACEHOLDERS_NO_SECONDARY,
  DEFAULT_ASSET_TYPE,
} from '../constants';

import { ASSET_TYPES } from '~/constants';

export const mapAssetIdPath = assetType => {
  switch (assetType) {
    case 'rig':
    case 'well':
      return ['attributes', 'asset_id'];
    case 'frac_fleet':
    case 'pad':
    default:
      return ['id'];
  }
};

export const getPadFracFleetId = (fracFleets = []) => {
  const currentFracFleet = fracFleets.find(fracFleet => fracFleet === fracFleet.current)?.id;
  const lastCurrentFracFleet = fracFleets.reduce((a, b) => {
    return new Date(a.lastCurrentAt) > new Date(b.lastCurrentAt) ? a : b;
  }, {});

  if (!isEmpty(currentFracFleet)) {
    return currentFracFleet.fracFleet?.id;
  }
  return lastCurrentFracFleet.fracFleet?.id;
};

export const getRequestOptions = (assetType, assetFields = []) => ({
  sort: 'name',
  order: 'asc',
  fields: [`${assetType}.name`, `${assetType}.status`, ...assetFields],
});

export const formatAsset = ({
  asset,
  group = null,
  activeWellId = null,
  isRequiredAssetId,
  isPrimaryAsset,
  isDrillingPlatformApp,
}) => {
  if (!asset) return null;

  const formattedAsset = {
    id: +asset.assetId || +asset.id,
    type: asset.type,
    name: asset.name,
  };

  if (isRequiredAssetId) {
    formattedAsset.id = +asset.id;
    formattedAsset.assetId = +asset.assetId;
  }

  if (group) {
    formattedAsset.group = group;
  }
  if (asset.type === ASSET_TYPES.rig.type) {
    formattedAsset.activeWellId = Number(asset.activeWell?.id) || null;
    if (isDrillingPlatformApp) {
      formattedAsset.activeWellId = Number(asset.activeWell?.assetId) || null;
    }
  }
  // NOTE: we use deserializer which transform keys and values to camelCase
  if (asset.type === 'interventionUnit') {
    formattedAsset.activeWellId = Number(asset.activeWell?.id) || null;
  }
  if (asset.type === ASSET_TYPES.well.type || asset.type === DEFAULT_ASSET_TYPE) {
    formattedAsset.status = Number(asset.id) === activeWellId ? ACTIVE_STATUS : null;
  }
  if (asset.type === ASSET_TYPES.pad.type) {
    formattedAsset.parentFracFleetId = asset.parentFracFleetId;

    formattedAsset.status = asset.active && asset.current ? ACTIVE_STATUS : null;

    if (isPrimaryAsset && !asset.parentFracFleetId) {
      formattedAsset.status = null;
    }
  }
  return formattedAsset;
};

export const sortAsset = curr => (curr.status === ACTIVE_STATUS ? -1 : 1);

export const getPrimaryAssetFields = (primaryAssetType, assetFields, isDrillingPlatformApp) => {
  const customAssetFields = [...assetFields];
  if (
    primaryAssetType === ASSET_TYPES.rig.type ||
    primaryAssetType === ASSET_TYPES.intervention_unit.type
  ) {
    customAssetFields.push(`${primaryAssetType}.active_well`);
  }

  if (isDrillingPlatformApp) return [...customAssetFields, 'rig.active_child'];

  return customAssetFields;
};

export const getSearchPlaceholder = (assetType, isSecondaryAssetPresent = true) => {
  const assetPlacehoders = isSecondaryAssetPresent
    ? ASSET_TYPE_SEARCH_PLACEHOLDERS
    : ASSET_TYPE_SEARCH_PLACEHOLDERS_NO_SECONDARY;
  return assetPlacehoders[assetType] || 'Search...';
};
